export const returnRouteName = (routeKey: RouteKey) => {
  switch (routeKey) {
    case "a":
      return "ads";
    case "b":
      return "bing";
    case "f":
      return "facebook";
    case "t":
      return "twitter";
    case "k":
      return "tiktok";
    case "s":
      return "apple";
    case "o":
      return "organic";
    default:
      return "unknown";
  }
};
